<template>
  <div>
    <!--div class="row mt-6">
        <div class="col col-sm-12 col-md-12">
          <p class="text-h6 text-uppercase text-center font-weight-medium">
            Datos de la negociación
          </p>
          <hr />
        </div>
      </div-->

    <div class="row">
      <div class="col col-md-4 col-xs-4">
        <img
          class="m-10"
          src="../../../assets/img/marnLogo.png"
          alt="Girl in a jacket"
          width="250"
          height="70"
        />
      </div>
      <div class="col col-md-4 col-xs-4"></div>
    </div>
    <v-row cols="12" style="margin-top:-50px!important">
      <v-col xl="4" lg="4" md="4" xs="4"> </v-col>

      <v-col xl="4" lg="4" md="4" xs="4">
        <div class="text-center">
          <h5><strong>MINISTERIO DE AMBIENTE Y</strong></h5>
        </div>
      </v-col>

      <v-col xl="4" lg="4" md="4" xs="4"> </v-col>
    </v-row>
    <v-row cols="12" style="margin-top:-30px!important">
      <v-col xl="4" lg="4" md="4" xs="4"> </v-col>

      <v-col xl="4" lg="4" md="4" xs="4">
        <div class="text-center">
          <h5><strong>RECURSOS NATURALES</strong></h5>
        </div>
      </v-col>

      <v-col xl="4" lg="4" md="4" xs="4">
        <div class="text-center"></div>
      </v-col>
    </v-row>
    <v-row cols="12" style="margin-top:-30px!important">
      <v-col xl="12" lg="12" md="12" xs="12">
        <div class="text-center">
          <h5>
            <strong>DIRECCION DE GESTION AMBIENTAL Y RECURSOS NATURALES</strong>
          </h5>
        </div>
      </v-col>
    </v-row>
    <v-row cols="12">
      <v-col xl="4" lg="4" md="4" xs="4"> </v-col>
      <v-col xl="4" lg="4" md="4" xs="4"> </v-col>
      <v-col xl="4" lg="4" md="4" xs="4">
        <img :src="this.pathQR" alt="qr" width="150" height="150" />
      </v-col>
    </v-row>
    <v-row cols="12">
      <v-col xl="12" lg="12" md="12" xs="12">
        <div class="text-center">
          <h5>
            Ingreso de Expediente
          </h5>
        </div>
      </v-col>
    </v-row>
    <hr class="ml-6 mr-6" />
    <v-row cols="12">
      <v-col xl="12" lg="12" md="12" xs="12">
        <div class="text-left">
          <h3>
            <strong class="ml-6">Datos del Proyecto</strong>
          </h3>
        </div>
      </v-col>
    </v-row>
    <v-row cols="12" class="mr-6">
      <v-col xl="12" lg="12" md="12" xs="12">
        <v-row cols="12" class="mt-0">
          <v-col xl="3" lg="3" md="3" xs="3">
            <div class="ml-6 text-start">
              <h6>No. Expediente:</h6>
            </div>
          </v-col>
          <v-col xl="3" lg="3" md="3" xs="3">
            <div class="text-start">
              <h6>{{ this.no_Expediente }}</h6>
            </div>
          </v-col>
          <v-col xl="3" lg="3" md="3" xs="3">
            <div class="text-start">
              <h6>Categoría:</h6>
            </div>
          </v-col>
          <v-col xl="3" lg="3" md="3" xs="3">
            <div class="text-start">
              <h6>{{ this.categoria }}</h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="3" lg="3" md="3" xs="3">
            <div class="ml-6 text-start">
              <h6>Nombre del Proyecto:</h6>
            </div>
          </v-col>
          <v-col xl="9" lg="9" md="9" xs="9">
            <div class="text-start">
              <h6>
                {{ this.nombre_Proyecto }}
              </h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="3" lg="3" md="3" xs="3">
            <div class="ml-6 text-start">
              <h6>Dirección:</h6>
            </div>
          </v-col>
          <v-col xl="9" lg="9" md="9" xs="9">
            <div class="text-start">
              <h6>
                {{ this.direccion_Proyecto }}
              </h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="3" lg="3" md="3" xs="3">
            <div class="ml-6 text-start">
              <h6>Sector:</h6>
            </div>
          </v-col>
          <v-col xl="9" lg="9" md="6" xs="9">
            <div class="text-start">
              <h6>{{ this.sector }}</h6>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <hr class="ml-6 mr-6" />
    <v-row cols="12">
      <v-col xl="12" lg="12" md="12" xs="12">
        <div class="text-left">
          <h3>
            <strong class="ml-6">Datos de la Persona o Empresa</strong>
          </h3>
        </div>
      </v-col>
    </v-row>
    <v-row cols="12" class="mr-6">
      <v-col xl="12" lg="12" md="12" xs="12">
        <v-row cols="12" class="mt-0">
          <v-col xl="2" lg="2" md="2" xs="2">
            <div class="ml-6 text-start">
              <h6>Nombre:</h6>
            </div>
          </v-col>
          <v-col xl="10" lg="10" md="10" xs="10">
            <div class="text-start">
              <h6>{{ this.nombre }}</h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="2" lg="2" md="2" xs="2">
            <div class="ml-6 text-start">
              <h6>Nit:</h6>
            </div>
          </v-col>
          <v-col xl="2" lg="2" md="2" xs="2">
            <div class="text-start">
              <h6>
                {{ this.nit }}
              </h6>
            </div>
          </v-col>
          <v-col xl="1" lg="1" md="1" xs="1">
            <div class="text-start">
              <h6>DPI:</h6>
            </div>
          </v-col>
          <v-col xl="2" lg="2" md="2" xs="2">
            <div class="text-start">
              <h6>
                {{ this.dpi }}
              </h6>
            </div>
          </v-col>
          <v-col xl="1" lg="1" md="1" xs="1">
            <div class="text-start">
              <h6>Correo:</h6>
            </div>
          </v-col>
          <v-col xl="2" lg="2" md="2" xs="2">
            <div class="text-start">
              <h6>
                {{ this.email }}
              </h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="3" lg="3" md="3" xs="3">
            <div class="ml-6 text-start">
              <h6>Representante Legal:</h6>
            </div>
          </v-col>
          <v-col xl="9" lg="9" md="6" xs="9">
            <div class="text-start">
              <h6></h6>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row cols="12" class="mt-20 ml-6">
      <v-col xl="12" lg="12" md="12" xs="12">
        <p>
          El proyecto {{ this.nombre_Proyecto }} registrado en el MARN con el
          número de Expediente {{ this.no_Expediente }} ha sido ingresado
          exitosamente, el mismo continuará con el trámite correspondiente.
        </p>
        <p>
          ORIGINAL: CLIENTE
        </p>
        <p>
          DUPLICADO: MARN
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    datosExpedientePdf: {},
  },
  data() {
    return {
      no_Expediente: "",
      categoria: "",
      nombre_Proyecto: "",
      direccion_Proyecto: "",
      sector: "",
      nombre: "",
      nit: "",
      dpi: "",
      email: "",
      pathQR: "",
      imgQR: false
    };
  },
  created() {},
  mounted() {
    if (this.datosExpedientePdf) {
      //   this.desserts.push({
      //     codigo: this.datosExpedientePdf.cobro,
      //     categoria: this.datosExpedientePdf.categoria,
      //     catidad: 1,
      //     precio: this.datosExpedientePdf.monto,
      //     total: this.datosExpedientePdf.monto,
      //   });
      this.no_Expediente = this.datosExpedientePdf.no_Expediente;
      this.categoria = this.datosExpedientePdf.categoria;
      this.nombre_Proyecto = this.datosExpedientePdf.nombre_Proyecto;
      this.direccion_Proyecto = this.datosExpedientePdf.direccion_Proyecto;
      this.sector = this.datosExpedientePdf.sector;

      if (this.datosExpedientePdf.nombres_Individual) {
        this.nombre =
          this.datosExpedientePdf.nombres_Individual +
          " " +
          this.datosExpedientePdf.apellidos_Individual;
      }

      if (this.datosExpedientePdf.dpi_Individual) {
        this.dpi = this.datosExpedientePdf.dpi_Individual;
      }
      if (this.datosExpedientePdf.nit_Propietario) {
        this.nit = this.datosExpedientePdf.nit_Propietario;
      }

      if (this.datosExpedientePdf.nombre_Comercial) {
        this.nombre = this.datosExpedientePdf.nombre_Comercial;
      }

      if (this.datosExpedientePdf.nit_Empresa) {
        this.nit = this.datosExpedientePdf.nit_Empresa;
      }
      if (this.datosExpedientePdf.pathQR) {
        // let newPath = this.datosExpedientePdf.pathQR.replace(/\\/g, "/");
        // //server
        // //this.pathQR = "http://preprod-wsayb.marn.gob.gt" + newPath;
        // //local
        // this.pathQR = "https://localhost:44396" + newPath;
        this.pathQR = this.datosExpedientePdf.pathQR;
        this.imgQR = true;
      }
      // console.log(this.pathQR);
      // this.monto = this.datosPdf.monto;
      // this.descripcion = this.datosPdf.descripcion;
      // this.fechaEmision = this.datosPdf.fechaEmision;
      // this.no_Expediente = this.datosPdf.no_Expediente;
      // this.categoria = this.datosPdf.categoria;
      // this.nitProponente = this.datosPdf.nitProponente;
      // this.nombreProponente = this.datosPdf.nombreProponente;
      // this.direccionProponente = this.datosPdf.direccionProponente;
      // this.telefonoProponente = this.datosPdf.telefonoProponente;
    }
  },
};
</script>
<style lang=""></style>
